module.exports = __webpack_public_path__ + "img/screen2.1db27b57.jpg";